import axios from "axios";

// The staff portal proves who is acting by sending the verified admin email as
// `x-admin-email` on its own endpoints (/api/agency-management/...). Shared
// components (the forms editor, uploader and AI field pass) call axios directly,
// so rather than thread the email through each of them, install an interceptor
// that adds the header to staff-portal URLs only. Nothing else (S3 uploads,
// other APIs) ever gets it. Returns a function that removes the interceptor.
export function installStaffRequestHeader(adminEmail: string): () => void {
  const id = axios.interceptors.request.use((config) => {
    const url = config.url || "";
    if (url.startsWith("/api/agency-management/")) {
      config.headers.set("x-admin-email", adminEmail);
    }
    return config;
  });
  return () => axios.interceptors.request.eject(id);
}
